module.exports = __webpack_public_path__ + "img/cafe-badilico.9609ca0a.png";